import { render, staticRenderFns } from "./PresetLink.vue?vue&type=template&id=1bfec32a&"
import script from "./PresetLink.vue?vue&type=script&lang=js&"
export * from "./PresetLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports